import React from 'react';

import ConstructionIcon from '@mui/icons-material/Construction';
import { Alert, Paper, Stack, Typography } from '@mui/material';

import type { ChecklistCategory } from './types';

interface Props {
  category: ChecklistCategory;
}

export default function PlaceholderChecklistTab({ category }: Props) {
  return (
    <Paper variant="outlined" sx={{ borderRadius: 1.25, overflow: 'hidden' }}>
      <Stack spacing={2} sx={{ p: 3 }}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <ConstructionIcon color="primary" />
          <Typography variant="h6" fontWeight={700}>
            {category.label}
          </Typography>
        </Stack>
        <Typography color="text.secondary">{category.description}</Typography>
        <Alert severity="info">
          Skeleton tab is ready. Add this category's data hook, row builder, report card, and approval queue items here.
        </Alert>
      </Stack>
    </Paper>
  );
}
